export const HAKLAI_DOCUMENT_LABELS = Object.freeze({
  form2990Online: "טופס 2990 מקוון",
  deal: "עסקה",
  oldLinear: "לינארי ישן",
  mutav: "מוטב"
});

export const getHaklaiDealDocumentPrefix = (displayIndex) => (
  `${HAKLAI_DOCUMENT_LABELS.deal} ${displayIndex + 1}`
);
